import * as moment from 'moment';

import { CommunityModel, CommunityVendorModel } from "./CommunityModel";
import { CouponModel } from "./CouponModel";
import { CustomerGiveawayModel, CustomerGiveawaysModel, CustomerModel } from "./CustomerModel";
import { DisabledType, EventStatus, EventType } from "./Enums"; 
import { PackageVendorModel } from "./PackageModel";
import { TransactionModel } from "./TransactionModel";
import { VendorModel, VendorStoreModel } from "./VendorModel";

export class ScratchModel {

    public constructor(init?: Partial<Pick<ScratchModel, keyof ScratchModel>>) {
        if (init) {
            if (typeof init.endDateAt === 'string') {
                init.endDateAt = new Date(init.endDateAt);
            }
            if (typeof init.disabledAt === 'string') {
                init.disabledAt = new Date(init.disabledAt);
            }
            if (typeof init.createdAt === 'string') {
                init.createdAt = new Date(init.createdAt);
            }
            if (typeof init.updatedAt === 'string') {
                init.updatedAt = new Date(init.updatedAt);
            }
            if (typeof init.updatedAt === 'string') {
                init.updatedAt = new Date(init.updatedAt);
            }
            if (typeof init.vendor) {
                init.vendor = new VendorModel(init.vendor);
            }
            if (typeof init.coupons && init.coupons?.length) {
                init.coupons = init.coupons.map((item: any) => new CouponModel(item));
            }
            if(init.logoUrl != null) this.thumbnailUrl = init.logoUrl;
            Object.assign(this, init);
        }
    }

    id: number;
    vendorId: number; 
    communityId: number; 
    probability: number; 
    couponsCount: number;
    redeemedQuantity: number;
    customersCount: number;
    winnersCount: number;
    rewardsQuantity: number;
    maxAttempts: number;
    intervalHours: number;
    
    name: string;
    description: string;
    logoUrl: string;
    colorTheme: string;
    terms: string; 
    

    type: EventType  
    status: EventStatus;

    isActive: boolean;
    showInApp: boolean;

    showPrizes: boolean = false;
    showProbability: boolean = false;

    disabledType: DisabledType;

    endDateAt: Date; 
    disabledAt: Date;
    createdAt: Date;
    updatedAt: Date;
    deletedAt: Date;
    approvedAt: Date;

    vendor: VendorModel;
    community: CommunityModel; 
    communityVendor: CommunityVendorModel;

    coupons: CouponModel[]=[]; 

    price: number;
    stores: VendorStoreModel[];
    thumbnailUrl: string;
    packageVendor: PackageVendorModel;

    giveaways: CustomerGiveawayModel[]=[];

    timeRemaining: string;
    progress: number;
    counterInterval: any;


    get isExpired(): boolean {

        const todayDate = new Date().toISOString().slice(0, 10);
        const expiration = new Date(this.endDateAt);
        const expirationString = expiration.toISOString().slice(0, 10);

        const valid = moment(todayDate).isAfter(moment(expirationString));

        return valid;
    }

}

export class ScratchCustomerModel {

    public constructor(init?: Partial<Pick<ScratchCustomerModel, keyof ScratchCustomerModel>>) {
        if (init) {
            if (typeof init.createdAt === 'string') {
                init.createdAt = new Date(init.createdAt);
            }
            if (typeof init.updatedAt === 'string') {
                init.updatedAt = new Date(init.updatedAt);
            }
            if (typeof init.updatedAt === 'string') {
                init.updatedAt = new Date(init.updatedAt);
            }
            if (typeof init.updatedAt === 'string') {
                init.updatedAt = new Date(init.updatedAt);
            }
            if (typeof init.coupon) {
                init.coupon = new CouponModel(init.coupon);
            }
            if (typeof init.scratch) {
                init.scratch = new ScratchModel(init.scratch);
            }
            if (typeof init.customer) {
                init.customer = new CustomerModel(init.customer);
            }
            if (typeof init.transaction) {
                init.transaction = new TransactionModel(init.transaction);
            }
            Object.assign(this, init);
        }
    }

    id: number; 
    scratchId: number; 
    customerId: number; 
    couponId: number;

    couponName: string;

    
    createdAt: Date;
    updatedAt: Date;
    deletedAt: Date;

    coupon: CouponModel;
    customer: CustomerModel;
    scratch: ScratchModel;
    transaction: TransactionModel;
}

export class ScratchStickerLinkModel {

    public constructor(init?: Partial<Pick<ScratchStickerLinkModel, keyof ScratchStickerLinkModel>>) {

        if (init) {
            Object.assign(this, init);
            if (init.scratch) this.scratch = new ScratchModel(init.scratch);
        }
    }

    scratch: ScratchModel;
    customerId: number;
    customerEmail: string;
    loyaltyPlanCustomerStickerId: number;
    alreadyPlayed: boolean;
    // Codigo de la jugada: valida el un solo uso aunque el sello ya no exista
    uniqueLinkCode: string;
}
